import type { Icon as IconType, IconWeight } from '@phosphor-icons/react';
import { clsx } from 'clsx';
import type { ComponentPropsWithoutRef } from 'react';

interface IconProps extends ComponentPropsWithoutRef<'svg'> {
  Icon: IconType;
  variant?: IconWeight;
  color?: string;
}

const PhosphorIcon = ({
  Icon,
  variant = 'regular',
  color,
  className,
  ...props
}: IconProps) => (
  <Icon
    {...props}
    className={clsx(className, 'block')}
    weight={variant}
    color={color}
  />
);

export default PhosphorIcon;
